<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="eye-hidden"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path id="Path_1482" data-name="Path 1482" d="M0,0H24V24H0Z" fill="none" />
    <path
      id="Path_1483"
      data-name="Path 1483"
      d="M12,19a6.943,6.943,0,0,1-2.5-.5m11.386-6.037C18.99,15.967,15.495,19,12,19M19.079,8.921a15.135,15.135,0,0,1,1.8,2.612.987.987,0,0,1,0,.935M5,19,19,5M9.773,14.227a3.15,3.15,0,1,1,4.455-4.455"
      fill="none"
      :stroke="clr ? clr : '#56606B'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
    <path
      id="Path_1484"
      data-name="Path 1484"
      d="M17.044,6.956A8.421,8.421,0,0,0,12,5C8.505,5,5.01,8.033,3.118,11.533a.987.987,0,0,0,0,.935,14.744,14.744,0,0,0,3.838,4.577"
      fill="none"
      :stroke="clr ? clr : '#56606B'"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
    />
  </svg>
</template>
